<template>
    <div class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
        <vx-card :title="data.title">
            <div v-for="(browser, index) in data.chartData" :key="browser.id" :class="{'mt-4': index}">
                <div class="flex justify-between">
                    <div class="flex flex-col">
                        <span class="mb-1">{{ browser.name }}</span>
                        <h4>{{ browser.ratio }}%</h4>
                    </div>
                    <div class="flex flex-col text-right">
                                <span class="flex -mr-1">
                                    <span class="mr-1">{{ browser.comparedResult }}</span>
                                    <feather-icon :icon=" browser.comparedResult < 0 ? 'ArrowDownIcon' : 'ArrowUpIcon'" :svgClasses="[browser.comparedResult < 0 ? 'text-danger' : 'text-success'  ,'stroke-current h-4 w-4 mb-1 mr-1']"></feather-icon>
                                </span>
                        <span class="text-grey">{{ browser.time | time(true) }}</span>
                    </div>
                </div>
                <vs-progress :percent="browser.ratio"></vs-progress>
            </div>
        </vx-card>
    </div>
</template>

<script>

    export default {
        name: "card-lists",
        props: {
            data: Object
        }
    };
</script>
